/* eslint-disable no-undef */

import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { getHeaders } from "../../utility/getHeader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CardComponent from "../../components/cards/CardComponent";

import Header from "../../components/Header";
import Layout from "../../layout/Layout";
import { format } from "date-fns";
import { AdvanceInput } from "../../components/Buttons/advanceinput";
import { SubmitButton } from "../../components/Buttons/Textfield";
import fetchData from "../../functions/fetchData";

export default function EditProfile() {
  let currentDate = format(new Date(), "yyyy-MM-dd");
  const [data, setData] = useState([]);
  const [dataid, setDataid] = useState(0);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // alert(e.target);
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handlePasswordUpdate = async (e) => {
    e.preventDefault();

    // Validate all fields are filled
    if (!newPassword || !confirmPassword) {
      setError("All fields are required!");
      toast.error("All fields are required!");
      return;
    }

    // Check if new passwords match
    if (newPassword !== confirmPassword) {
      setError("New passwords do not match!");
      toast.error("New passwords do not match!");
      return;
    }

    // Validate new password length
    if (newPassword.length < 6) {
      setError("New password must be at least 6 characters long!");
      toast.error("New password must be at least 6 characters long!");
      return;
    }

    try {
      const response = await axios.put(
        `/update-password`,
        { 
          newPassword: newPassword 
        },
        getHeaders()
        
      );
      
      if (response.data.success) {
        toast.success(response.data.msg || "Password updated successfully!");
        // Clear all fields after successful update
        setNewPassword("");
        setConfirmPassword("");
        setError("");
      } else {
        toast.error(response.data.msg || "Failed to update password!");
      }
    } catch (error) {
      console.error("Error updating password:", error);
      
      // Handle specific error responses
      if (error.response?.status === 401) {
        toast.error(error.response?.data?.error || "Authentication failed. Please login again.");
        setError(error.response?.data?.error || "Authentication failed.");
      } else if (error.response?.status === 403) {
        toast.error(error.response?.data?.error || "Session expired. Please login again.");
      } else if (error.response?.status === 400) {
        toast.error(error.response?.data?.error || "Invalid input data!");
        setError(error.response?.data?.error || "Invalid input data!");
      } else {
        toast.error(error.response?.data?.error || error.response?.data?.msg || "Error while updating password!");
      }
    }
  };

  useEffect(() => {
    const fetchAndSetData = async () => {
      try {
        await fetchData("users", setData, "id", {
          uname:
            localStorage.getItem("uname") || sessionStorage.getItem("uname"),
        });
        //console.log('Fetched data:', data); // Add this line for debugging
      } catch (error) {
        console.error("Error in useEffect:", error);
      }
    };

    fetchAndSetData();
  }, []);
  // Effect to extract the id from the data once it has been set
  useEffect(() => {
    if (data && data.length > 0) {
      const fetchedUserId = data[0].id; // Assuming you want the id of the first user
      setDataid(fetchedUserId);
      // console.log('Extracted User ID:', fetchedUserId);
    }
  }, [data]); // Runs every time the data changes
  return (
    <>
      <Layout>
        <Header title="Add New User" />
        <ToastContainer />
        <div className="row">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <CardComponent
              title="Edit Profile Information"
              headerColor="lightblue"
              pull="left"
              bodyClass="panel-body"
            >
              <div class="row">
                <div class="col-md-12">
                  <form onSubmit={handlePasswordUpdate}>
                    <div class="panel panel-default card-view">
                      <AdvanceInput
                        id="newPassword"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        type="password"
                        name="newPassword"
                        label="New Password (min 6 characters)"
                        required
                      />
                      <AdvanceInput
                        id="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        type="password"
                        name="confirmPassword"
                        label="Confirm New Password"
                        required
                      />

                      {error && <p style={{ color: "red" }}>{error}</p>}
                      <SubmitButton
                        type="submit"
                        name="Update Password"
                        cls="btn btn-darkblue btn-anim"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </CardComponent>
          </div>

          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            {/* <ProfileCard user={data} /> */}
            <CardComponent
              title="My Profile Information"
              headerColor="lightblue"
              pull="left"
              bodyClass="panel-body"
            >
              <div class="row">
                <div class="col-md-12">
                  {data.map((item, index) => (
                    <>
                      <div className="info-item" key={index}>
                        <span>Username:</span> {item.uname}
                      </div>
                      <div className="info-item">
                        <span>Email:</span> {item.email}
                      </div>
                      <div className="info-item">
                        <span>Contact:</span> {item.contact}
                      </div>
                      <div className="info-item">
                        <span>Last Login:</span> {item.last_loggedin}
                      </div>
                    </>
                  ))}
                </div>
              </div>
            </CardComponent>
          </div>
        </div>
      </Layout>
    </>
  );
}
